import * as Sentry from '@sentry/browser';

const capturedStorageErrors = new Set();

/**
 * Captures a localStorage error to Sentry, deduplicating by action and key.
 * @param {string} action - The localStorage action (e.g., 'getItem', 'setItem')
 * @param {string} key - The localStorage key
 * @param {Error} error - The error to capture
 * @param {string} [context] - Optional context describing where the error occurred
 */
const captureStorageError = (action, key, error, context = 'localStorage operation') => {
  const captureKey = `${action}:${key}`;
  if (capturedStorageErrors.has(captureKey)) return;
  capturedStorageErrors.add(captureKey);
  Sentry.captureException(error, {
    extra: {
      message: `Non-fatal localStorage error: ${context}`,
      action,
      key,
    },
  });
};

export default captureStorageError;
